import type { DealerResultType } from "../../../common-deprecated/utils/dealerConstants";

export const TRADE_IN_AEM_DEALER_SET_DEALER = "tradeInAemDealer/setDealer";

export type TradeInAemSetDealerType = {
    type: typeof TRADE_IN_AEM_DEALER_SET_DEALER;
    dealer: DealerResultType | null;
};

export const tradeInAemDealerSetDealer = (dealer: DealerResultType | null): TradeInAemSetDealerType => ({
    type: TRADE_IN_AEM_DEALER_SET_DEALER,
    dealer,
});

export type TradeInAemDealerActionsType = TradeInAemSetDealerType;
